export default __webpack_public_path__ + "images/9775dbe0d69d53abd82120c117884805-home_and_garden_small.webp";